<template>
  <ModalComponent
    :name="`confirmationModal-${uid}`"
    width="500"
    height="auto"
    :adaptive="true"
    :click-to-close="true"
    @before-close="modalClosed"
  >
    <div class="flex flex-col justify-between py-3">
      <div class="flex justify-between px-5">
        <h2
          class="flex items-center gap-x-1.5 text-xl font-semibold text-gray-900 lg:text-lg"
        >
          <span>{{ modalTitle }}</span>
        </h2>
        <button
          class="flex h-8 w-8 items-center justify-center rounded-md bg-[#EEEFF0D4] text-[#808080] outline-none"
          @click="$modal.hide('newConfirmationModal')"
        >
          <TimesSmall />
        </button>
      </div>
      <div class="mt-3 flex h-16 items-start px-5">
        <p class="text-sm font-medium">
          {{ message }}
        </p>
      </div>
      <div class="border-t-2 pt-2">
        <div class="flex justify-end gap-2 px-5">
          <GhostButton @click="closeModal">
            Cancel
          </GhostButton>
          <PrimaryButton @click="submitButtonClicked">
            Yes, continue
          </PrimaryButton>
        </div>
      </div>
    </div>
  </ModalComponent>
</template>

<script>
export default {
  name: 'ConfirmMessageModal',

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      default: 'Confirmation required',
    },
  },

  emits: ['confirm', 'modal-closed'],

  data() {
    return {
      uid: null,
    }
  },

  watch: {
    isOpen(val) {
      if (val) {
        this.$modal.show(`confirmationModal-${this.uid}`)
      }
    },
  },

  mounted() {
    this.uid = this.$.uid
  },

  methods: {
    submitButtonClicked() {
      this.$emit('confirm')
      this.$modal.hide(`confirmationModal-${this.uid}`)
    },
    closeModal() {
      this.$modal.hide(`confirmationModal-${this.uid}`)
    },
    modalClosed() {
      this.$emit('modal-closed')
    },
  },
}
</script>
